import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Box,
  IconButton,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { Edit } from '@mui/icons-material';
import { fetchTappingPoints } from "./../../actions/tappingPointsActions";
import LoadingBackdrop from "../Common/LoadingBackdrop";

const AVATAR_BG = '/img/avatar_man_large.webp';

const TappingPointsTable = ({ searchText = "" }) => {
  const dispatch = useDispatch();
  const tapping_points = useSelector((state) => state.tapping_points.tapping_points);
  const loading = useSelector((state) => state.tapping_points.isLoading);

  useEffect(() => {
    dispatch(fetchTappingPoints());
  }, [dispatch]);

  const filteredTappingPoints = tapping_points?.filter(point =>
    point.tapping_point_name.toLowerCase().includes(searchText.toLowerCase())
  );

  if (loading) {
    return <LoadingBackdrop />;
  }

  return (
    <Box sx={{ py: 2 }}>
      <TableContainer
        component={Paper}
        sx={{
          marginTop: 3,
          boxShadow: 2,
          borderRadius: 1,
          overflow: 'hidden'
        }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell width="100px"><strong>Image</strong></TableCell>
              <TableCell><strong>Asset Name</strong></TableCell>
              <TableCell align="right" width="100px"><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredTappingPoints?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} align="center" sx={{ py: 4 }}>
                  <Typography variant="subtitle1" color="text.secondary">
                    {searchText ? "No tapping points found matching your search" : "No tapping points available"}
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              filteredTappingPoints?.map((point) => (
                <TableRow
                  key={point.tapping_point_id + point.tapping_point_name}
                  sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}
                >
                  <TableCell>
                    <Box
                      sx={{
                        display: 'inline-block',
                        backgroundColor: 'primary.dark',
                        borderRadius: 1,
                        overflow: 'hidden',
                        position: 'relative',
                        '&:hover': {
                          '& .background-image': {
                            opacity: 1
                          }
                        }
                      }}
                    >
                      {point.tapping_point_image_url ? (
                        <>
                          <Box
                            component="img"
                            src={point.tapping_point_image_url}
                            alt={point.tapping_point_name}
                            sx={{
                              height: '50px',
                              display: 'block',
                              position: 'relative',
                              zIndex: 2
                            }}
                          />
                          <Box
                            className="background-image"
                            component="img"
                            src={AVATAR_BG}
                            alt="Background"
                            sx={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              objectFit: 'contain',
                              opacity: 0,
                              transition: 'opacity 0.2s ease-in-out',
                              zIndex: 1
                            }}
                          />
                        </>
                      ) : (
                        <Typography variant="caption" color="text.secondary" sx={{ p: 1 }}>
                          No image
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle1">
                      {point.tapping_point_name === "Default Tapping Point" ? (
                        <strong>Default Background</strong>
                      ) : (
                        point.tapping_point_name
                      )}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                      <Tooltip title="Edit">
                        <IconButton
                          component={Link}
                          to={`/tapping-points/edit/${point.tapping_point_id}`}
                          sx={{ '&:hover': { backgroundColor: 'action.hover' } }}
                        >
                          <Edit />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TappingPointsTable;
